import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchCollectionPartners,
    createCollectionPartnerAction,
    deleteCollectionPartnerAction
} from "../../../utils/redux/collectionPartners/collectionPartnerActions";
import { collectionPartnerFields } from "../../../helpers/InputFields/InputFields";
import DynamicFormModal from "../../Modal/DynamicFormModal/DynamicFormModal";

const CollectionPartnerListing = () => {
    const dispatch = useDispatch();

    const { partners, isLoading } = useSelector(
        state => state.collectionPartner
    );

    const [modalConfig, setModalConfig] = useState({
        show: false,
        title: "",
        fields: [],
        initialData: {},
        onSubmit: null
    });

    useEffect(() => {
        dispatch(fetchCollectionPartners());
    }, [dispatch]);

    const openAddPartnerModal = () => {
        setModalConfig({
            show: true,
            title: "Add Collection Partner",
            fields: collectionPartnerFields,
            initialData: {},
            onSubmit: async (data) => {
                await dispatch(createCollectionPartnerAction(data));
            }
        });
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this partner?")) {
            await dispatch(deleteCollectionPartnerAction(id));
        }
    };

    return (
        <>
            <div className="d-flex flex-column align-items-center">
                <div className="d-flex my-4 w-100 justify-content-between">
                    <h3>Collection Partners</h3>
                    <button className="btn btn-primary" onClick={openAddPartnerModal}>
                        + Add Partner
                    </button>
                </div>

                <div className="w-100">
                    <table className="table table-sm align-middle mt-3">
                        <thead className="table-secondary">
                            <tr>
                                <th className="p-3">Partner Name</th>
                                <th className="p-3">Partner Logo</th>
                                <th className="p-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {partners.length ? (
                                partners.map(item => (
                                    <tr key={item._id}>
                                        <td>{item.name}</td>
                                        <td>
                                            <img
                                                src={item.logo?.url}
                                                alt={item.name}
                                                style={{ width: 200, height: 60, objectFit: "cover" }}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-sm text-danger"
                                                onClick={() => handleDelete(item._id)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center text-muted">
                                        {isLoading ? "Loading..." : "No partners found"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <DynamicFormModal
                show={modalConfig.show}
                title={modalConfig.title}
                fields={modalConfig.fields}
                initialData={modalConfig.initialData}
                onSubmit={modalConfig.onSubmit}
                uploadOptions={{
                    module: "collectionPartner"
                }}
                onHide={() =>
                    setModalConfig(prev => ({ ...prev, show: false }))
                }
            />
        </>
    );
};

export default CollectionPartnerListing;
